import { Navigate, Outlet } from "react-router";
import {
    useApplicationParameters,
    type ApplicationParameterKeys,
} from "src/api/client-api/appParams/useApplicationParameters";

type FeatureSwitchProtectionProps = {
    featureSwitch: ApplicationParameterKeys;
};

export const FeatureSwitchProtection = (props: FeatureSwitchProtectionProps) => {
    const { featureSwitch } = props;
    const { isFeatureActivated } = useApplicationParameters();

    if (!isFeatureActivated(featureSwitch)) {
        return <Navigate to="/settings" replace />;
    }

    return <Outlet />;
};
